// src/components/dashboard/mastercard/TermsAndConditions.tsx
import React from 'react';

interface TermsAndConditionsProps {
  onClose: () => void;
}

export function TermsAndConditions({ onClose }: TermsAndConditionsProps) {
  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px' }}>
        <div className="modal-header">
          <h2>Quicko MasterCard Terms and Conditions</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div style={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
          <h3>Introduction</h3>
          <p>
            These Terms and Conditions govern the use of your Belobaba MasterCard Virtual Card issued by Quicko.
            By applying for and using the card, you agree to be bound by these Terms and Conditions.
          </p>

          <h3>1. Definitions</h3>
          <p>
            <strong>"Card"</strong> means the Belobaba MasterCard Virtual Card issued to you.<br />
            <strong>"Issuer"</strong> means Quicko, the financial institution that issues the Card.<br />
            <strong>"We", "us", "our"</strong> refers to Belobaba and/or the Issuer as appropriate.<br />
            <strong>"You", "your"</strong> refers to the person who applies for and is issued a Card.
          </p>

          <h3>2. Card Issuance and Activation</h3>
          <p>
            2.1. Eligibility: You must be at least 18 years old and have completed our identity verification process.<br />
            2.2. Your Card will be activated upon successful completion of the application process.<br />
            2.3. The Card is virtual only and no physical card will be issued.
          </p>

          <h3>3. Card Usage</h3>
          <p>
            3.1. The Card can be used for online and contactless transactions where MasterCard is accepted.<br />
            3.2. The Card cannot be used for certain restricted activities as detailed in our Acceptable Use Policy.<br />
            3.3. You must not use the Card for any illegal purposes.
          </p>

          <h3>4. Fees and Charges</h3>
          <p>
            4.1. We may charge fees for the use of the Card as set out in our Fee Schedule.<br />
            4.2. All applicable fees will be deducted from your Card balance.<br />
            4.3. Foreign currency transactions may incur additional fees.
          </p>

          <h3>5. Card Security</h3>
          <p>
            5.1. You must keep your Card details secure at all times.<br />
            5.2. You must not share your Card details, PIN, or security information with anyone else.<br />
            5.3. If you suspect that your Card security has been compromised, you must notify us immediately.
          </p>

          <h3>6. Lost or Stolen Cards</h3>
          <p>
            6.1. You must notify us immediately if your device containing the virtual card is lost or stolen.<br />
            6.2. You may be liable for unauthorized transactions if you fail to notify us promptly.<br />
            6.3. We may suspend or cancel your Card if we suspect fraud or security concerns.
          </p>

          <h3>7. Changes to Terms and Conditions</h3>
          <p>
            7.1. We may change these Terms and Conditions at any time by giving you notice.<br />
            7.2. If you do not agree with the changes, you may close your Card account.<br />
            7.3. Your continued use of the Card after the changes take effect constitutes your acceptance of the changes.
          </p>

          <h3>8. Governing Law</h3>
          <p>
            These Terms and Conditions are governed by the laws of Spain.
          </p>

          <h3>9. Privacy</h3>
          <p>
            9.1. We will collect, use, and disclose your personal information in accordance with our Privacy Policy.<br />
            9.2. By applying for and using the Card, you consent to such collection, use, and disclosure.
          </p>

          <div style={{ marginTop: '30px', fontStyle: 'italic' }}>
            <p>Last updated: April 2025</p>
            <p>Quicko Financial Services, S.L.</p>
          </div>
        </div>
        <div style={{ padding: '20px', borderTop: '1px solid #eee', textAlign: 'right' }}>
          <button 
            onClick={onClose} 
            style={{ 
              padding: '10px 20px', 
              background: '#003DA5', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer' 
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}